import React, { ReactElement } from 'react';
import { Trans } from 'react-i18next';
import { ETableCellEnum } from './table.enum';
import { STableActiveCell, STableCellPlaceholder } from './table.styles';

type TProps = {
  children: React.ReactNode;
  type: ETableCellEnum;
};

const TableCellComponent = ({ children, type }: TProps): ReactElement => (
  <STableActiveCell>
    {{
      [ETableCellEnum.Max]: children ?? (<STableCellPlaceholder>
        <Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.max" />
      </STableCellPlaceholder>),
      [ETableCellEnum.CustomDays]: children ?? (<STableCellPlaceholder>
        <div><Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.days" /></div>
        <div><Trans i18nKey="limits.standardLimits.table.period.column.cell.placeholder.max" /></div>
      </STableCellPlaceholder>),
    }[type as string] || children}
  </STableActiveCell>
);

export default TableCellComponent;
